// External Dependencies:
import React from 'react'
import { v4 as uuidv4 } from 'uuid'

class Text extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			value: props.value,
			hasError: false
		}

		this.uid = uuidv4()
	}

	static defaultProps = {
		type: 'text',
		label: false,
		handleError: false,
		focus: false
	}

	componentDidMount() {
		if ( this.props.focus ) {
			this.input.focus()
		}
	}

	componentDidUpdate( prevProps, prevState ) {
		if ( this.props.focus ) {
			this.input.focus()
		}
	}

	handleChange = ( e ) => {
		this.setState( {
			value: e.target.value
		} )

		this.validate( e.target.value )

		this.props.onChange( this.props.id, e.target.value )
	}

	handleError = ( e ) => {
		this.props.handleError( this.props.id, hasError )
	}

	validate = ( value ) => {
		var hasError = false

		switch( this.props.type ) {
			case 'email':
				hasError = ! value.match( /\S+@\S+\.\S+/ )

				break

			default:
				return
		}

		this.setState( {
			hasError: hasError
		} )

		if ( this.props.handleError ) {
			this.props.handleError( this.props.id, hasError )
		}
	}

	render() {
		const { id, label, value, required, type, uncontrolled, note } = this.props
		const { hasError } = this.state
		let theValue = value || ''
		let className = hasError ? 'form-item form-text has-error' : 'form-item form-text'

		if ( type ) {
			className += ' form-' + type
		}

		if ( uncontrolled ) {
			theValue = undefined
		}

		return (
			<div className={ className }>
				{ label &&
					<label htmlFor={ this.uid }>
						<span dangerouslySetInnerHTML={ { __html: label } } />

						{ required &&
							<span className="-required"> *</span>
						}
					</label>
				}

				<input type={ type } id={ this.uid } name={ id } value={ theValue } required={ required } onChange={ this.handleChange } ref={ e => this.input = e } />

				{ note &&
					<div className="form-item-note" dangerouslySetInnerHTML={ { __html: note } } />
				}
			</div>
		)
	}
}

export default Text
